import { entryMessage } from "./useEntryOperation"
import { refundReasons } from "../../withdrawalFinanceText"

// Words for open administrative entry operations (API ADR 0014), shared by
// "Operations in progress" and the Entries Action Logs.
export const actionLabel = operation => operation.origin === "waitingList" ? "Waiting list withdrawal"
  : operation.action === "add" ? (operation.slotType === "WILD_CARD" ? "Add wild card" : "Add entry")
    : operation.refund ? "Withdrawal with refund" : "Withdrawal"

export const amountOf = money => Number.isFinite(money?.amount) && money?.currency ? ` ${money.amount} ${money.currency}` : ""

export const moneyText = operation => {
  const amount = amountOf(operation.money)
  const withdrawn = operation.action === "withdraw" && operation.sporting === "confirmed" ? "Withdrawn · " : ""
  return withdrawn + ({
    chargePending: `Charge${amount} not confirmed yet`,
    notCharged: "Not charged (no wallet debit)",
    settling: `Checking the charge${amount} to refund it`,
    refundFailed: `Refund${amount} not credited`,
    refundPending: `Refund${amount} pending`,
    refundUnverified: `Refund${amount} not credited`,
    noRefund: "No refund",
  }[operation.money?.state] || "Payment state unavailable")
}

const reasons = {
  PAYMENTS_UNCONFIRMED: "Payments has not confirmed this operation after an hour of automatic retries.",
  REFUND_UNCONFIRMED: "The refund of the charge has not been confirmed after an hour of automatic retries.",
  PAYMENT_RECORD_UNCONFIRMED: "The entry is confirmed; its payment record has not been confirmed yet.",
  REFUND_NOT_CREDITED: "The withdrawal is applied; the refund has not been credited.",
  DEBIT_UNVERIFIABLE: "A charge made before this release can no longer be verified. Check the payer's wallet before acting.",
  ...refundReasons,
  SUPERADMIN_RESOLUTION_REQUIRED: "Only a SuperAdmin can resolve this refund.",
  ENTRY_OPERATION_NOT_RESOLVABLE: "This refund can no longer be resolved here. Reload the page.",
  INVALID_REFUND_RESOLUTION: "Choose a decision and explain it in at least 10 characters.",
  ENTRY_OPERATION_CONFIRMED: "The entry is already confirmed. Use Retry to finish the operation.",
  ENTRY_OPERATION_SETTLING: "The entry was undone and its money is being settled. Use Retry.",
  WAITING_LIST_FENCE_RELEASED: "This waiting list withdrawal can no longer run. Close it, then withdraw the entry from the list if needed.",
  ENTRY_OPERATION_NOT_FOUND: "This operation is no longer open in this competition. Reload the page.",
}
// Codes an add's own banner also shows (a refusal, Close) are worded once, in entryMessage;
// a withdrawal's refund reasons, in the Withdrawals labels module.
export const reasonText = code => reasons[code] || entryMessage(code)

// A Retry, Close or Resolution request refused with ENTRY_OPERATION_IN_PROGRESS met another Retry of the same operation
// (Events moveOperation reclaim). An add, withdrawal or move refused with that code met another operation on the entry or a
// phase lock, so the wording is the request's only.
const requestReasons = {
  ENTRY_OPERATION_IN_PROGRESS: "This operation is already being retried. Wait for that result.",
}
export const requestRefusalText = code => requestReasons[code] || reasonText(code)
